const SUCCESS = 'green';
const WARNING = 'orange';
const DANGER = 'rgb(209, 52, 56)'

export const ColorHelper = {
    SUCCESS,
    WARNING,
    DANGER
}